export default __webpack_public_path__ + "assets/fonts/c831a01ce843eab8e64918b4e59eadbb.ttf";